import useAiAccess from './useAiAccess'
import type { WhoToAsk } from '../utils/permissionReason'

/**
 * Who the user asks about an action they cannot do: their team's managers,
 * from GET /ai-access/:customer/me (cached a minute, shared with useAiAccess).
 * Until /me answers it knows nobody, and the sentence says "a Manager".
 *
 * customer is the customer NAME (account.customer.name).
 */
export function useWhoToAsk(customer: string | undefined): WhoToAsk {
  const aiAccess = useAiAccess(customer)
  return { teamManagers: aiAccess.teamManagers, inTeam: !!aiAccess.teamName }
}

export default useWhoToAsk
